export default "__VITE_ASSET__CWaQXFmY__"